import TreeConnector from '@components/ListV2/components/table/tree/TreeConnector';
import { Box, Stack } from '@mui/material';
import { OrderConditionsTestIds } from '../../../../../../../../../utils/testIds/OrderConditions.testIds';
import {
  AvailabilityEnum,
  CompactAvailability,
} from '../../../../../../../../products/ProductTypes';
import OrderConditionSplitLabel from '../../../../../../../conditions/components/OrderConditionSplitLabel';
import { OrderConditionSplitLabelParts } from '../../../../../../../conditions/orderCondition.utils';
import OrderErrorIcon from '../../../../OrderErrorIcon';

const CONTENT_INSET = 4;

interface OrderSplitTreeItemProps extends OrderConditionSplitLabelParts {
  availability: AvailabilityEnum | CompactAvailability;
  isSelected: boolean;
  isLastChild: boolean;
  hasErrors: boolean;
  testId?: string;
  onSelect: () => void;
}

const OrderSplitTreeItem = ({
  availability,
  availabilityLabel,
  classificationLabel,
  isSelected,
  isLastChild,
  hasErrors,
  testId,
  onSelect,
}: OrderSplitTreeItemProps) => (
  <Box
    component="button"
    type="button"
    aria-pressed={isSelected}
    test-id={testId}
    onClick={onSelect}
    sx={(theme) => ({
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 1, 1, CONTENT_INSET),
      border: 'none',
      borderRadius: `${theme.shape.borderRadiusMd}px`,
      textAlign: 'left',
      cursor: 'pointer',
      backgroundColor: isSelected ? theme.palette.action.selected : 'transparent',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    })}
  >
    <Box
      sx={(theme) => ({
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: theme.spacing(CONTENT_INSET),
        color: 'custom.border.primary',
      })}
    >
      <TreeConnector isLastChild={isLastChild} />
    </Box>

    <Stack direction="row" sx={{ alignItems: 'center', columnGap: 0.75, minWidth: 0, flex: 1 }}>
      <OrderConditionSplitLabel
        availability={availability}
        availabilityLabel={availabilityLabel}
        classificationLabel={classificationLabel}
      />

      {hasErrors && (
        <OrderErrorIcon
          testId={OrderConditionsTestIds.SPLIT_TREE_ITEM_ERROR_ICON}
          sx={{ marginLeft: 'auto' }}
        />
      )}
    </Stack>
  </Box>
);

export default OrderSplitTreeItem;
